import {Injectable} from '@angular/core';
import {SimpleExcelModel, SheetsModel} from '@app/types';
import {Workbook, Alignment, Fill, Font} from 'exceljs';
import * as fs from 'file-saver';

@Injectable({
    providedIn: 'root',
})
export class SimpleExcelService {
    constructor() {}

    async simpleXLSX(config: SimpleExcelModel) {
        const workbook = new Workbook();
        const fileName = config.fileName;

        for (const sheet of config.sheets) {
            const worksheet = workbook.addWorksheet(sheet.sheetName);

            // --- Títulos Principales ---
            if (sheet.header && sheet.header.length > 0) {
                sheet.header.forEach(title => {
                    const titleRow = worksheet.addRow([title]);
                    titleRow.font = { name: 'Calibri', size: 14, bold: true };
                    worksheet.mergeCells(titleRow.number, 1, titleRow.number, sheet.columns.length);
                });
            }
            
            if (sheet.lineBreak > 0) {
                for (let i = 0; i < sheet.lineBreak; i++) worksheet.addRow([]);
            }

            // --- Encabezados de Columnas ---
            const columnNames = sheet.columns.map(c => c.columnName);
            const headerRow = worksheet.addRow(columnNames);
            headerRow.eachCell((cell) => {
                cell.font = { name: 'Calibri', color: { argb: 'FFFFFFFF' }, bold: true };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF3D6091' } };
                cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            });

            // --- Asignar anchos de columna ---
            worksheet.columns = sheet.columns.map(c => ({
                key: c.columnKey,
                width: (c as any).width || 20 // Usar ancho personalizado o 20 por defecto
            }));

            // --- Filas de Datos ---
            sheet.data.forEach((item: any) => {
                const rowData = sheet.columns.map(col => item[col.columnKey]);
                const row = worksheet.addRow(rowData);
                row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                    const columnDef = sheet.columns[colNumber - 1];
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                    if (columnDef.type === 'currency') {
                        cell.numFmt = '$#,##0.00';
                    }
                });
            });

            // --- Fila de Total (si se proporciona) ---
            if ((sheet as any).totalRow) {
                const totalRowData = (sheet as any).totalRow;
                const totalRow = worksheet.addRow(Object.values(totalRowData));
                totalRow.font = { bold: true };
                totalRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                    const key = Object.keys(totalRowData)[colNumber - 1];
                    if (key.toLowerCase().includes('importe') || key.toLowerCase().includes('total')) {
                        cell.numFmt = '$#,##0.00';
                    }
                    cell.alignment = { vertical: 'middle', horizontal: 'center' };
                });
            }
        }

        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            fs.saveAs(blob, `${fileName}.xlsx`);
        });
    }
}
